import React, {useState} from "react";
import useToggler from '~/hooks/useToggler';

import Loader        from "~/components/loader"
import OverlayModal  from "~/components/overlayModal";
import CardPaginator from "~/components/paginator"

import Cashout     from '~/services/cashouts';

import CashoutForm from "./Form/CashoutForm"
import Completed   from "./Form/Completed"
import Card        from "./Card"


const TypesPaginator = ({selectedCurrency, bg})=> {

  const [selectedType   , setSelectedType]      = useState({});
  const [overlayOpen    , setOverlayOpen]       = useState({ form: false, completed: false });
  const [message        , setMessage]           = useState('');
  const [paginatorReset , togglePaginatorReset] = useToggler();

  if(paginatorReset) return <Loader type={19} center />;

  return (
    <div className="m-t-30">
      <CardPaginator endpoint={Cashout.paginators.types} card={Card} options={{setSelectedType, setOverlayOpen, bg}} qs={{currencyId: selectedCurrency}} />

      <OverlayModal bottom opened={overlayOpen.form} onClose={()=> { setOverlayOpen({form: false, completed: false}); togglePaginatorReset(); }}>
        <CashoutForm selectedType={selectedType} setMessage={setMessage} setOverlayOpen={setOverlayOpen} />
      </OverlayModal>

      <OverlayModal opened={overlayOpen.completed}>
        <Completed message={message} setOverlayOpen={setOverlayOpen} />
      </OverlayModal>
    </div>
  );

}

export default TypesPaginator;

